import { ProductSupplierInventoryReceiptDoc } from '@gooduncles/gu-app-schema';
import { Empty, Skeleton } from 'antd';
import { FC } from 'react';

import useSWRProductSupplier from 'src/hooks/swr/useSWRProductSupplier';

import CardItem from 'src/atomic-components/atoms/CardItem/CardItem';
import Label from 'src/atomic-components/atoms/TextItem/Label';
import Value from 'src/atomic-components/atoms/TextItem/Value';

import InboundTransactionTable from './ProductInboundTransaction/InboundTransactionTable';

interface ProductSupplierReceiptViewProps {
  supplierReceipt: ProductSupplierInventoryReceiptDoc;
}

const ProductSupplierReceiptView: FC<ProductSupplierReceiptViewProps> = ({ supplierReceipt }) => {
  const { supplier, isLoading } = useSWRProductSupplier(supplierReceipt.supplierId);

  if (!supplier) {
    if (isLoading) {
      return <Skeleton active />;
    }
    return <Empty description='거래처 정보가 없습니다.' />;
  }

  return (
    <div
      style={{
        boxSizing: 'border-box',
        backgroundColor: 'white',
        height: '100%',
        border: '1px solid rgba(5, 5, 5, 0.06)',
        borderRadius: 4,
        padding: 16,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <CardItem>
        <Label>{supplierReceipt.transactionDate}</Label>
        <Value>{supplier.name}</Value>
      </CardItem>
      <CardItem>
        <Label>특이사항</Label>
      </CardItem>
      {supplierReceipt.checkList.map((item, idx) => (
        <CardItem key={supplierReceipt._id + 'check' + idx}>
          <Value style={{ justifyContent: 'flex-start', fontSize: 14, lineHeight: '21px' }}>• {item.content}</Value>
        </CardItem>
      ))}
      <CardItem>
        <Label>입고 내역</Label>
      </CardItem>
      {supplierReceipt.inboundTransactionIds.length > 0 && (
        <InboundTransactionTable transactionIds={supplierReceipt.inboundTransactionIds} />
      )}
    </div>
  );
};

export default ProductSupplierReceiptView;
